import { useEffect, useRef } from 'react';

/**
 * Avisa a página da pílula do cartão (RDV-14) sempre que ela muda; a página as guarda para as pílulas do topo
 * (RDV-15). A referência do callback pode mudar a cada renderização sem disparar um aviso novo.
 */
export function useAvisoDaPilula(pilula: string, onPilula?: (pilula: string) => void) {
  const avisar = useRef(onPilula);
  avisar.current = onPilula;

  useEffect(() => {
    avisar.current?.(pilula);
  }, [pilula]);
}
